module.exports = __webpack_public_path__ + "static/img/bannerImage.d76879c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerImage.jpg
// module id = y2t/
// module chunks = 14